import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonContent, IonButton, IonLabel, IonFooter, ModalController } from '@ionic/angular/standalone';
import { Training } from '../app.types';
import { MessageModule } from 'primeng/message';
import { InAppBrowser } from '@capacitor/inappbrowser';
import { ApiService } from '../api.service';
import { AppLinkService } from '../app-link.service';

@Component({
  selector: 'app-extrapt',
  templateUrl: './extrapt.page.html',
  styleUrls: ['./extrapt.page.scss'],
  standalone: true,
  imports: [IonFooter, 
    IonLabel, IonButton, IonContent, CommonModule, FormsModule,
    MessageModule
  ]
})
export class ExtraptPage implements OnInit {

  t: Training
  accepted = false
  constructor(
    private modalController: ModalController,
    private api: ApiService,
    private appLink: AppLinkService
  ) { }


  ngOnInit() {
  }

  async accept() {
    console.log('Accepted')
    if(this.accepted) {
      this.closeAccepted()
      return
    }

    if(this.t.company_training_type == 1) {
      const handledInApp = await this.appLink.handleUrl(this.t.company_training_link)
      if(!handledInApp) {
        await InAppBrowser.openInExternalBrowser({
          url: this.t.company_training_link,
        })
      }
    }
    else if(this.t.company_training_type == 2) {
      this.api.sendCompanyEmail(this.t).catch((err) => console.error(err))
      this.api.presentAlert("Grazie", "Verrai contattato via e-mail dai nostri partner.")
    }
    else if(this.t.company_training_type == 3) {
      this.api.sendCompanyApiCall(this.t)
      this.api.presentAlert("Grazie", "Hai sbloccato i PT extra.")
    }
    

    this.accepted = true

  }

  async closeAccepted() {
    const modal = await this.modalController.getTop()
    modal.canDismiss = true
    this.modalController.dismiss({done:true})
  }

  async ignore() {  
    console.log('Ignored')
    const modal = await this.modalController.getTop()
    modal.canDismiss = true
    this.modalController.dismiss()
  }

}
